import { useEffect } from "react";

export const useEscape = (onClose, active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose, active]);
};
